import { useFeatureFlags } from '@usap/core'

const useInvisibleRecaptcha = () => {
  const { f42 } = useFeatureFlags() as { f42: unknown }
  if (typeof f42 === 'string' || typeof f42 === 'boolean' || typeof f42 === 'number') {
    return f42 === 'b' || f42 === '1' || f42.toString() === 'true'
  }
  return false
}
export default useInvisibleRecaptcha
